import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      maxWidth: '100%',

      '& input': {
        fontSize: theme.typography.appFontSize,
      },
    },
    textContainer: {
      textAlign: 'right',
    },
    tooltipSize: {
      fontSize: theme.typography.pxToRem(14),
      marginLeft: '0.313rem',
    },
    description: {
      lineHeight: 1,
      marginTop: 25,
      marginBottom: 15,
    },
    textAreaStyles: {
      '& .MuiInputBase-multiline': {
        paddingTop: 5,
        paddingRight: 0,
        paddingLeft: 0,
        paddingBottom: 5,
        marginTop: 16,
      },
    },
  };
});

export default useStyles;
